function trimTrailingSlash(url) {
  return String(url || "").replace(/\/+$/, "");
}
function resolveApiBase() {
  const fromEnv = process.env.REACT_APP_BACKEND_URL;
  if (fromEnv != null && String(fromEnv).trim() !== "") {
    return trimTrailingSlash(fromEnv);
  }
  if (process.env.NODE_ENV === "development") {
    return "http://127.0.0.1:5000";
  }
  return "";
}

export const API_BASE = resolveApiBase();

export async function parseApiJson(res) {
  const raw = await res.text();
  if (!raw.trim()) {
    return { json: null, isJson: false, status: res.status, ok: res.ok };
  }
  try {
    return { json: JSON.parse(raw), isJson: true, status: res.status, ok: res.ok };
  } catch {
    return { json: null, isJson: false, status: res.status, ok: res.ok };
  }
}
